var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RemoteTable',{ref:"table",attrs:{"form":_vm.form,"table":_vm.table},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
var property = ref.property;
return [(property === 'code')?[_vm._v(" "+_vm._s(_vm.$root.getBusinessName(row.code))+" ")]:_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }